export default __webpack_public_path__ + "static/media/tela_firewall.9476091a.png";